const isEmail = (data) => {
  let value = data.value;
  // let validationanem = data.value.validationName
  value = value.trim();
  const pattern = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return (pattern.test(value)) ? true : "Please enter valid email address";
}

export default isEmail;
